module.exports = __webpack_public_path__ + "static/media/artwork_17.1ffb94cb.jpg";